import { Box, Grid, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { Colaborador } from "./Colaboradores";
import { Block, Check, Edit as EditIcon } from "@mui/icons-material";

interface CardColaboradorMobileProps {
  colaborador: Colaborador;
  activeTab: "ativos" | "inativos";
  canEditColaborador: boolean;
  canAtivarInativarColaborador: boolean;
  handleEditClick: (item: Colaborador) => void;
  setColaboradorId: (item: string) => void;
  handleDeleteClick: () => void;
  handleActivateClick: () => void;
}

export const CardColaboradorMobile = ({ 
  colaborador, 
  activeTab, 
  canEditColaborador, 
  canAtivarInativarColaborador, 
  handleEditClick, 
  handleDeleteClick, 
  handleActivateClick, 
  setColaboradorId 
}: CardColaboradorMobileProps) => {
  return (
    <Paper className="card-colaboradores">
      <Grid container size={12} style={{ marginBottom: 20 }}>
      <Grid size={8} style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-all' }}>
        <Box>
          <Typography className="colaborador-nome">{colaborador.nome}</Typography>
          <Typography color="primary">{colaborador.usuario}</Typography>
        </Box>
      </Grid>
      <Grid size={4} style={{ textAlign: 'right' }}>
          <Box>
            { activeTab === 'inativos' ? (
              <Typography>
                <Tooltip title="Ativar colaborador">
                  <IconButton 
                    aria-label="Ativar" 
                    className="colaborador-icon-direita" 
                    onClick={() => { 
                      handleActivateClick(); 
                      setColaboradorId(String(colaborador.id)); 
                    }}>
                    <Check style={{ color: '#00AF39' }} />
                  </IconButton>
                </Tooltip>
              </Typography>
            ) : (
              <Typography>
                {canEditColaborador && (
                  <Tooltip title="Editar colaborador">
                    <IconButton aria-label="Editar" className="colaborador-icon-esquerda" onClick={() => handleEditClick(colaborador)}>
                      <EditIcon style={{ color: '#00AF39' }} />
                    </IconButton>
                  </Tooltip>
                )}
                {canAtivarInativarColaborador && (
                  <Tooltip title="Inativar colaborador">
                    <IconButton 
                      aria-label="Excluir"
                      className="colaborador-icon-direita"
                      onClick={() => { 
                        handleDeleteClick(); 
                        setColaboradorId(String(colaborador.id)); 
                      }} 
                    >
                      <Block style={{ color: 'red' }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>

      <Grid container size={12} style={{ marginTop: 20, whiteSpace: "normal", wordBreak: "break-all" }}>
        <Grid size={6} style={{ textAlign: 'left' }}>
          <Typography color="textSecondary">Cadastro:</Typography>
          <Typography color="textPrimary">{new Date(colaborador.created_at).toLocaleDateString('pt-BR')}</Typography>
        </Grid>
        <Grid size={6} style={{ textAlign: 'left' }}>
          <Typography color="textSecondary">Grupo de acesso:</Typography>
          <Typography color="textPrimary">{colaborador.grupo_acesso?.nome}</Typography>
        </Grid>
      </Grid>
    </Paper>
  )
}
